export const CUSTOM_LAUNCHER_STYLE_ID = 'custom';

export const WEB_WIDGET_LAUNCHER_STYLES = [
  { id: '1', icon: 'i-lucide-message-circle' },
  { id: '2', icon: 'i-lucide-message-square' },
  { id: '3', icon: 'i-lucide-messages-square' },
  { id: '4', icon: 'i-lucide-message-square-text' },
  { id: '5', icon: 'i-lucide-message-circle-more' },
];

export const bubbleStyleToType = style =>
  style === '5' ? 'expanded_bubble' : 'standard';

export const bubbleTypeFromPopupMessage = message =>
  message?.trim() ? 'expanded_bubble' : 'standard';

export const getLauncherStyleById = styleId =>
  WEB_WIDGET_LAUNCHER_STYLES.find(style => style.id === styleId);

export const isCustomLauncherStyle = styleId =>
  styleId === CUSTOM_LAUNCHER_STYLE_ID;
